

/**
 *
 * @class OperationalMeasureParams
 *
 * Helper to pass more complicated values when working with the new Operational Measure model dialog
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    William Au
 * @date      February 2022
 *
 */

export class OperationalMeasureDialogParams {

  public corridor:  string    = '';
  public start: string    = '';
  public end:   string    = '';

  /** standard constructor */
  public constructor(init?: Partial<OperationalMeasureDialogParams>) {

    Object.assign(this, init);
  }
}
